import React from 'react';
import PropTypes from 'prop-types';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import HouseholdSectionMemberLayout from './HouseholdSectionMemberLayout';

const householdSectionMemberOverride = buildFacetDesignOverride();

function HouseholdSectionMember({
  collection,
}) {
  return (
    <MetaFormInline
      resource={collection?.resources()?.head()}
      layout={HouseholdSectionMemberLayout}
      noIndividualSubmitButtons
      padding={'none'}
      metaOverrideSet={householdSectionMemberOverride}
    />
  );
}

HouseholdSectionMember.propTypes = {
  collection: PropTypes.object.isRequired,
};

export default HouseholdSectionMember;
